import React from 'react';
import {Bids, Header, } from '../../components'
import 'react-html5video/dist/styles.css';
import { DefaultPlayer as Video } from 'react-html5video';
import videolink from '../../assets/new.mp4'
import splatter from '../../assets/splatter3.png'
import splatter1 from '../../assets/Splatter4.png'
import splatter03 from '../../assets/splatter03.png'
import splatter04 from '../../assets/splatter112.png'
import splatter05 from '../../assets/splatter132.png'
import poster from '../../assets/poster.png'


const Home = () => {

  return <div>
    <div style={{position:'fixed', zIndex: -1}}>
          <Video poster={poster} autoPlay loop muted controls={[]} style={{width:'1700px',}}>
            <source src={videolink} type='video/webm'/>
          </Video>
          
    </div>
    <div style={{position:'fixed', zIndex: -1,width:'119%'}}>
    





      
    </div>
          
    <div style={{background: 'rgba(0,0,0,0.6)', position:'fixed', zIndex: -1, width: '1700px', height: '100%'}}>
      </div>      
      <div style={{alignItems:'center', textAlign:'center', marginTop: 150, position:'absolute', width:'100%'}}>
          <p style={{fontSize: 25, color:'White'}}>Our Latest and Share ParLock NFTs</p>
          <span style={{fontSize: 17, color:'White'}}>Daily Base Upload</span>
      </div>
   <Header />
   
   <Bids title="Post On =>  Instagram + Twitter + NFT Calender + Reddit "  />
  </div>;
};

export default Home;
